import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { FileUploadHelperService } from '../../../../core/services/file-upload-helper.service';

@Component({
  selector: 'app-file-upload',
  standalone: true,
  imports: [TranslocoPipe, CommonModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.css'
})
export class FileUploadComponent implements OnChanges {
  @Input() toast!: ToastComponent;
  @Output() uploadCompleted = new EventEmitter<{ success: boolean }>();

  constructor(protected fileUploadHelper: FileUploadHelperService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.toast) {
      this.fileUploadHelper.attachToast(this.toast);
    }

    if (this.uploadCompleted) {
      this.fileUploadHelper.attachUploadCompleted(this.uploadCompleted);
    }
  }
}
